// extracted by mini-css-extract-plugin
module.exports = {"item":"AccordionGroup_item__rpnK_"};